import type { RouteObject } from 'react-router-dom';
import { createElement } from 'react';
import { RedirectIfAuth } from '@/app/router/ProtectedRoute';
import { AppShell } from '@/shared/ui/layout/AppShell';
import LoginPage from '@/pages/login';
import NotFoundPage from '@/pages/not-found';
import PrivacyPage from '@/pages/privacy';
import AccountDeletionPage from '@/pages/account-deletion';
import ReceiptPage from '@/pages/receipt';
import TrackPage from '@/pages/track';
import { FeaturesNotificationsBell } from '@/features/notifications';
import { useAuthState } from '@/entities/auth';

// Tracking page is PUBLIC. We still wrap it with AppShell so the bottom nav /
// side rail are visible (the bell only shows when the visitor is signed in).
const TrackShell = () => {
  const { isAuthenticated } = useAuthState();
  return createElement(AppShell, {
    headerActions: isAuthenticated ? createElement(FeaturesNotificationsBell) : null,
    children: TrackPage,
  });
};

export const publicRoutes: RouteObject[] = [
  {
    path: '/login',
    element: createElement(RedirectIfAuth, null, LoginPage),
  },
  {
    path: '/track',
    element: createElement(TrackShell),
  },
  {
    path: '/privacy',
    element: PrivacyPage,
  },
  {
    // PUBLIC, NO AUTH — anyone with the link/QR can view the payment receipt.
    path: '/receipt/:id',
    element: ReceiptPage,
  },
  {
    path: '/account-deletion',
    element: AccountDeletionPage,
  },
  {
    path: '*',
    element: NotFoundPage,
  },
];
